import { useState } from "react";
import { Link } from "react-router-dom";
import { Icon } from '../components/Icons';
import '../styles/Password-reset.css';

const CheckUserName = () => {
  const [username, setUsername] = useState('');
  const [error, setError] = useState('');
  const [serverError, setServerError] = useState('');
  const [success, setSuccess] = useState(false);
  const [loading, setLoading] = useState(false);

  const handleSubmit = async () => {
    setError('');
    setServerError('');

    if (!username.trim()) {
      setError('Please enter your username to continue.');
      return;
    }

    setLoading(true);
    try {
      const response = await fetch("/timesheets/forgotPassword", {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ userName: username }),
      });

      if (response.ok) {
        setSuccess(true);
      } else {
        const text = await response.text();
        setServerError(text || 'No account found with that username. Please check and try again.');
      }
    } catch {
      setServerError('Something went wrong. Please try again later.');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="pr-page">

      {/* Left panel */}
      <div className="pr-left">
        <div className="pr-brand">
          <div className="pr-brand-icon-wrap">
            <Icon.Key size={36} color="#fff" strokeWidth={1.5} />
          </div>
          <h1>Forgot Password?</h1>
          <p>No worries — we'll help you recover access to your account in seconds.</p>
        </div>
      </div>

      {/* Right card */}
      <div className="pr-right">
        <div className="pr-card">
          <div className="pr-card-icon-wrap">
            {success ? (
              <Icon.CheckCircle size={26} color="#16a34a" strokeWidth={1.5} />
            ) : (
              <Icon.Search size={26} color="#3730a3" strokeWidth={1.5} />
            )}
          </div>

          {success ? (
            <>
              <h2>Check Your Email</h2>
              <p className="pr-card-sub" style={{ 
                color: '#15803d', 
                background: '#f0fdf4', 
                border: '1px solid #bbf7d0', 
                padding: '16px', 
                borderRadius: '11px', 
                marginTop: '16px',
                lineHeight: '1.5',
                textAlign: 'left'
              }}>
                📧 A password reset link has been sent to your registered email address. Please check your inbox and click the link to reset your password.
              </p>
              <div className="pr-back" style={{ marginTop: '24px' }}>
                <Link to="/login">
                  <Icon.ChevronRight size={14} color="#3730a3" style={{ transform: 'rotate(180deg)', marginRight: 4 }} />
                  Back to Login
                </Link>
              </div>
            </>
          ) : (
            <>
              <h2>Find Your Account</h2>
              <p className="pr-card-sub">Enter your username and we'll send a reset link to your registered email.</p>

              <div className="pr-field">
                <label className="pr-label" htmlFor="check-username">Username</label>
                <div className="pr-input-wrap">
                  <span className="pr-input-icon"><Icon.User size={15} color="#94a3b8" /></span>
                  <input
                    id="check-username"
                    type="text"
                    className={`pr-input ${error ? 'pr-input-error' : ''}`}
                    placeholder="Enter your username"
                    value={username}
                    onChange={(e) => { setUsername(e.target.value); setError(''); setServerError(''); }}
                    onKeyDown={(e) => e.key === 'Enter' && handleSubmit()}
                    disabled={loading}
                  />
                </div>
                {error && (
                  <span className="pr-error-text">
                    <Icon.AlertCircle size={13} color="#e11d48" style={{ marginRight: 4, verticalAlign: 'middle' }} />
                    {error}
                  </span>
                )}
                {serverError && (
                  <span className="pr-error-text">
                    <Icon.AlertCircle size={13} color="#e11d48" style={{ marginRight: 4, verticalAlign: 'middle' }} />
                    {serverError}
                  </span>
                )}
              </div>

              <button className="pr-btn" onClick={handleSubmit} disabled={loading}>
                {loading ? 'Sending...' : <>Continue <Icon.ArrowRight size={17} color="#fff" style={{ marginLeft: 4 }} /></>}
              </button>

              <div className="pr-back">
                <Link to="/login">
                  <Icon.ChevronRight size={14} color="#3730a3" style={{ transform: 'rotate(180deg)', marginRight: 4 }} />
                  Back to Login
                </Link>
              </div>
            </>
          )}
        </div>
      </div>

    </div>
  );
};

export default CheckUserName;
